module.exports = __webpack_public_path__ + "static/assets/d84cdb7f4b9567882511ab47f63e342b.svg";